import { createContext, useContext } from 'react';
import { Vehicle } from 'types/vehicle';

type VehicleListContext = {
  vehicles: Vehicle[];
  vehiclesCount: number;
  isFetching: boolean;
  loadMore: () => void;
  getFilters: () => Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
  refreshQuery: () => void;
  localUpdate: (vehicleId: number, values: Partial<Vehicle>) => void;
};

const defaultValue: VehicleListContext = {
  vehicles: [],
  vehiclesCount: 0,
  isFetching: false,
  loadMore: () => {},
  getFilters: () => ({}),
  setFilters: () => {},
  refreshQuery: () => {},
  localUpdate: () => {},
};

export const VehicleListContext = createContext(defaultValue);

export const useVehicleListContext = () => {
  const context = useContext(VehicleListContext);
  return context;
};
